import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=d9f8328e&scoped=true&"
import script from "./PatientList.vue?vue&type=script&lang=js&"
export * from "./PatientList.vue?vue&type=script&lang=js&"
import style0 from "./PatientList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PatientList.vue?vue&type=style&index=1&id=d9f8328e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f8328e",
  null
  
)

export default component.exports